export default __webpack_public_path__ + "images/logoPopsugar.2aa4dd620431127e9141cdf9bdbf5d16.svg"